module.exports = __webpack_public_path__ + "img/community-takeover-graphic.aeb537eb.png";